<template>
	<div class="box">
        <DateRangeV2
            :start.sync="start_date"
            :end.sync="end_date"
            :dateSelect="true"
            :periodToShow="['personalise','jour','mois','mois_dernier']"
			@submit="loadTracking"
        />

        <CustomTable
            id_table="ca_tracking_connection"
            ref="table"
            :items="tracking"
            :busy.sync="table_busy"
            primaryKey="usercatracking_id"
            :hrefsRoutes="config_table_hrefs"
            :hide_if_empty="true"
            :externSlotColumns="['semencecontrol_statut']"
        >
			<template v-slot:[`custom-slot-cell(semencecontrol_statut)`]="{ data }">
				<span v-if="data.semencecontrol_statut">{{ $t('monte.congelation.statuts.'+data.semencecontrol_statut) }}</span>
			</template>
	    </CustomTable>

		<ModalEditQualification ref="modal_edit_qualification"/>
	</div>
</template>

<script type="text/javascript">
	import User from "@/mixins/User.js"
	import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'CAConnectionTracking',
		mixins: [User, Navigation],
		props: ['lot'],
		data () {
			return {
				start_date: new Date(new Date().setDate(new Date().getDate() - 31)),
				end_date: new Date(),
				table_busy: false,
				tracking: [],
				events_tab: {
					'TableAction::goToManageQualifsTiers': this.openModalQualifs
				},
				config_table_hrefs: {
					'tiers.tiers_rs': {
						routeUniqueName: 'tiersFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'tiers.tiers_id'
						}
					}
				}
			}
		},

		methods: {
			async loadTracking() {
				this.table_busy = true
				this.tracking = await this.getCaTrackingConnection(this.start_date.toDateInputValue(), this.end_date.toDateInputValue())
				this.table_busy = false
			},
			openModalQualifs(tiers_ids) {
				this.$refs.modal_edit_qualification.openModalFromTiers(tiers_ids)
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
			DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2'),
			ModalEditQualification: () => import('@/components/Contract/ModalEditQualification')
		}
	}

</script>